import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { SpecialProjectEMStatusEnum } from '../../enum';
import { CoreStatus } from '../CoreStatus';

interface SpecialProjectEMStatusProps {
  value: SpecialProjectEMStatusEnum;
}

const SpecialProjectEMStatusColor = {
  [SpecialProjectEMStatusEnum.Ready]: '#D19500',
  [SpecialProjectEMStatusEnum.InProduction]: '#06B6D4',
  [SpecialProjectEMStatusEnum.Exception]: '#DC2626',
  [SpecialProjectEMStatusEnum.OnHold]: '#A855F7',
  [SpecialProjectEMStatusEnum.Canceled]: '#83664B',
  [SpecialProjectEMStatusEnum.RequiredBooking]: '#EC4899',
  [SpecialProjectEMStatusEnum.DeliveryBooked]: '#3B82F6',
  [SpecialProjectEMStatusEnum.Completed]: '#22C55E',
  [SpecialProjectEMStatusEnum.Locked]: '#737373',
};
export const SpecialProjectEMStatus: FC<SpecialProjectEMStatusProps> = ({
  value,
}) => {
  const { t } = useTranslation('status', { keyPrefix: 'majorProjects' });

  return (
    <CoreStatus
      value={t(value, value)}
      backgroundColor={SpecialProjectEMStatusColor[value]}
    />
  );
};
